import React, { memo, useContext, useEffect, useState } from 'react';
import { Button, Drawer, Flex, Group, Paper, Space } from '@mantine/core';
import useFetch from '../../../Customhooks/useFetch';
import { baseUrl } from '../../../Constants/constant';
import { authContext } from '../../../context/AuthProvider.component';
import TableProductComponent from './Table/TableComponentProduct/TableProduct.component';
import TableBoxComponent from './Table/TableBox/TableBox.component';
import TablePalletComponent from './Table/TablePallet/TablePallet.component';
import TableTransportComponent from './Table/TableTransport/TableTransport.component';
import { notifications } from '@mantine/notifications';
import TableDisposalComponent from './Table/TableDisposal/TableDisposal.component';

interface DrawerProps {
    onComplete: () => void;
    isClose: any;
    isOpen: any;
}

const DrawerComponent: React.FC<DrawerProps> = ({
    onComplete,
    isClose,
    isOpen
}) => {
    const [componentdata, setcomponentData] = useState<any>();
    const [palletData, setPalletData] = useState<any>();
    const [boxData, setBoxData] = useState<any>();
    const [transportData, setTransportData] = useState<any>();
    const [DisposalData, setDisposalData] = useState<any>();
    const token = localStorage.getItem("token");
    const { computeId } = useContext<any>(authContext);
    const { data: getData, fetchData: fetchData } = useFetch({
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: token,
        },
    });
    const {
        data: SaveData,
        fetchData: saveDisposalData,

    } = useFetch(
        {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                token: token,
            },
            body: JSON.stringify({
                step : 'Report'
            })
        }
    );
    useEffect(() => {
        if (computeId) {
            fetchData(`${baseUrl}compute/lca/${computeId}`)
        }
    }, [computeId])

    const showNotification = (type: 'success' | 'error', message: string) => {
        notifications.show({
            title: type === 'success' ? 'Success' : 'Error',
            message,
            color: type === 'success' ? 'green' : 'red',
        });
    };

    useEffect(() => {
        if (getData?.data?.rows) {
            setcomponentData(getData?.data?.rows[0]?.ComputeComponents)
            setPalletData(getData?.data?.rows[0]?.ComputePallets)
            setBoxData(getData?.data?.rows[0]?.ComputePackages)
            setTransportData(getData?.data?.rows[0]?.ComputeJourneys)
            setDisposalData(getData?.data?.rows[0]?.ComputeDisposal)
        }
    }, [getData])

    const handleNext = async (e:any) => {
        e.preventDefault();
        await saveDisposalData(`${baseUrl}compute/lca/edit/${computeId}`)
        onComplete();
        isClose();
    }

    useEffect(() => {
        if (SaveData) {
            showNotification('success', 'Report Created Successfully');
        }
    }, [SaveData]);

    return (
        <>
            <Drawer offset={4} radius="md" size="lg" position='bottom' opened={isOpen} onClose={isClose} title="">
                <Paper shadow="md" withBorder radius="lg"><TableProductComponent data={componentdata} /></Paper>
                <Space h={'lg'} />
                <Flex
                    gap="md"
                    justify="space-between"
                    align="center"
                    direction="row"
                >
                    <Paper shadow='md' radius="lg" withBorder style={{ width: '50%' }}><TableBoxComponent data={boxData} /></Paper>
                    <Paper shadow='md' radius="lg" withBorder style={{ width: '50%' }}><TablePalletComponent data={palletData} /></Paper>
                </Flex>
                <Space h={'lg'} />
                <Paper shadow='md' radius="lg" withBorder ><TableTransportComponent data={transportData} /></Paper>
                <Space h={'lg'} />
                <Paper shadow='md' radius="lg" withBorder ><TableDisposalComponent data={DisposalData} /></Paper>
                <Space h={'xl'} />

                <Flex
                    justify="flex-start"
                    align="center"
                    bg="#fff"
                    style={{
                        position: 'sticky',
                        bottom: 0,
                        zIndex: 10,
                        padding: '1rem',
                        borderTop: '1px solid #e0e0e0',
                    }}
                >
                    <Group justify="flex-start" gap="xl">
                        <Button
                            variant="gradient"
                            radius={6}
                            gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                            size="lg"
                            onClick={(e) => handleNext(e) }
                        >
                            Compute LCA
                        </Button>
                    </Group>
                </Flex>
            </Drawer>

        </>
    )
}

export default memo(DrawerComponent);